import { useRef } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

export const DefaultItem = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    text-decoration: none;
    font-size: ${(props) => (props.selected && !props.disabled ? '28px' : '14px')};
    box-sizing: border-box;
    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-bottom-color: ${(props) => (props.selected ? 'var(--blue500)' : 'transparent')};
    font-weight: bold;
    color: var(--blue500);
    user-drag: none;

    @media (hover: hover) {
        &:hover:not([disabled]) {
            background-color: var(--gray50);
            border-color: var(--blue500);
        }
    }

    &[disabled] {
        cursor: default;
    }

    &::-moz-focus-inner {
        border: 0;
    }
`;

export const LightBlueItem = styled(DefaultItem)`
    color: var(--blue500);
    border-bottom-color: ${(props) => (props.selected ? 'var(--blue500)' : 'rgba(0, 86, 193, 0.4)')};

    &:hover:not([disabled]) {
        border-bottom-color: var(--blue500);
    }
`;

export const YellowItem = styled(DefaultItem)`
    color: var(--yellow800);
    border-color: var(--color-warning-default);

    &:hover:not([disabled]) {
        color: var(--yellow800);
        border-color: var(--yellow800);
    }
`;

export const GreenItem = styled(DefaultItem)`
    color: var(--color-success-default);
    border-color: var(--color-success-default);

    &:hover:not([disabled]) {
        color: var(--green900);
        border-color: var(--green900);
    }
`;

export const RedItem = styled(DefaultItem)`
    color: var(--color-error-default);
    border-color: var(--color-error-default);

    &:hover:not([disabled]) {
        color: var(--red700);
        border-color: var(--red700);
    }
`;

export const GreyItem = styled(DefaultItem)`
    color: var(--gray800);
    border-color: var(--gray200);

    &:hover:not([disabled]) {
        border-color: var(--gray800);
    }
`;

export const LightGreyItem = styled(DefaultItem)`
    color: var(--gray700);
    border-color: var(--gray200);

    &:hover:not([disabled]) {
        border-color: var(--gray700);
    }
`;

export const LightGreyUnderlinedItem = styled(DefaultItem)`
    color: var(--gray700);
    border-color: var(--gray700);

    &:hover:not([disabled]) {
        border-color: var(--gray700);
    }
`;

export const Index = styled.p``;

const navigationItemType = {
    DEFAULT: DefaultItem,
    RED: RedItem,
    YELLOW: YellowItem,
    GREEN: GreenItem,
    GREY: GreyItem,
    LIGHT_BLUE: LightBlueItem,
    LIGHT_GREY: LightGreyItem,
    LIGHT_GREY_UNDERLINED: LightGreyUnderlinedItem,
};

export const getNavigationItem = (type) => {
    if (!type || !navigationItemType.hasOwnProperty(type)) {
        return navigationItemType.DEFAULT;
    }

    return navigationItemType[type];
};

const NavigationItem = ({ index, selected, type, onSelectExercise, disabled }) => {
    const SpecificItem = getNavigationItem(type);
    const positionX = useRef(-1);
    const scrollXThreshold = 4; // 4px

    return (
        <SpecificItem
            href="#"
            // hack: per evitare il click al termine del drag si controlla la posizione
            // al primo mouse down e alla fine del click. se la posizione è diversa è un drag
            onMouseDown={(e) => {
                positionX.current = e.clientX;
            }}
            onClick={(event) => {
                if (Math.abs(event.clientX - positionX.current) < scrollXThreshold) {
                    onSelectExercise(event, index);
                    return;
                }

                event.preventDefault();
            }}
            role="tab"
            aria-controls={`tabpanel-${index}`}
            aria-selected={selected}
            aria-label={`Esercizio ${index + 1}`}
            selected={selected}
            disabled={disabled}
        >
            <Index selected={selected}>{index + 1}</Index>
        </SpecificItem>
    );
};

NavigationItem.propTypes = {
    index: PropTypes.number.isRequired,
    selected: PropTypes.bool,
    type: PropTypes.string,
    onSelectExercise: PropTypes.func,
    disabled: PropTypes.bool,
};

export default NavigationItem;
